<template>
  <div class="image-display">
    <ModuleTitle class="m-only">{{ $t('wo-de-xing-xiang-zhan-shi') }}</ModuleTitle>
    <h3 class="pc-only image-display__title">
      {{ $t('wo-de-xing-xiang-zhan-shi') }}
    </h3>
    <div class="mt-[36px] sm:mt-[7.5vw] flex justify-center sm:block sm:w-full mx-auto m-only">
      <Media v-if="character" :character="character" />
    </div>
    <VideoCarousel
      v-if="character && videoInfos"
      class="pc-only image-display__videos"
      :infos="videoInfos"
      :show-arrow="true"
      :show-progress="false"
      :show-controls="false"
      :is-2D-human="is2DHuman"
    />
    <div class="flex justify-center items-center pc-only mt-[40px]">
      <UpgradeButton
        v-if="props.character"
        @handle="emit('create-work')"
        :configType="props.character?.config_type"
        :text="$t('mian-fei-shi-yong-ci-ren-wu')"
      />
    </div>
  </div>
</template>
<script lang="ts" setup>
import UpgradeButton from '@/components/upgrade-button/index.vue';
import { useI18n } from 'vue-i18n';
import type { Character } from '~/api/interface/character';
import VideoCarousel from '~/design/widgets/video-carousel/index.vue';
import ModuleTitle from '../module-title.vue';
import Media from './media.vue';

const { isMobile } = useDevice();
const emit = defineEmits(['create-work']);
const { t: $t } = useI18n();

interface ImageDisplayProps {
  character?: Character | null;
  is2DHuman?: boolean;
}

const props = defineProps<ImageDisplayProps>();

const videoInfos = computed(() => {
  return (
    props.character?.preview_videos_detail?.map((item: any) => ({
      url: item.video_url,
      title: item.text,
    })) || []
  );
});

const wxPoster = [
  getFeUrl('/youyan-platform/png/character-video-mask3.png'),
  getFeUrl('/youyan-platform/png/character-video-mask4.png'),
];

const posters = ref<string[]>([]);

const videos = ref<any[]>([]);

function play(index: number) {
  videos.value.forEach((item, _index) => {
    if (_index !== index) {
      item.pause();
    }
  });

  videos.value[index]?.play();
}

onMounted(() => {
  if (props.character?.preview_videos?.length) {
    play(0);
    if (isMobile) {
      posters.value = wxPoster;
    }
  }
});
</script>
<style lang="scss" scoped>
.image-display {
  @apply flex-col items-center;
  padding: 160px 0;
  background-color: var(--x-back-3);
  @media (max-width: 680px) {
    background-size: contain;
    background-position: center;
    padding: 80px 0;
    background-color: unset;
  }
  .image-display__title {
    margin: 0;
    color: var(--x-text-1);
    font-size: 48px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .display-video {
    border: 4px solid var(--back-4);
    border-radius: 16px;
    overflow: hidden;
    z-index: 100;
    margin: 20px;
    flex: 1;
    position: relative;
  }

  .image-display__videos {
    margin-top: 40px;
    max-width: 1200px;
  }
}
</style>
